var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchCategoryNetworkingContentDelivery32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/32/Networking-Content-Delivery_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D27A8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A166FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/32/Networking-Content-Delivery_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 4,
    y: 4,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-19",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 46,
    height: 46
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/32/Networking-Content-Delivery_32",
    transform: "translate(9.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.741,26.067 C23.362,26.067 22.241,24.945 22.241,23.567 C22.241,22.189 23.362,21.067 24.741,21.067 C26.12,21.067 27.241,22.189 27.241,23.567 C27.241,24.945 26.12,26.067 24.741,26.067 M18.241,26.567 C18.241,27.945 17.12,29.067 15.741,29.067 C14.362,29.067 13.241,27.945 13.241,26.567 C13.241,25.189 14.362,24.067 15.741,24.067 C17.12,24.067 18.241,25.189 18.241,26.567 M6.728,26.067 C5.349,26.067 4.228,24.945 4.228,23.567 C4.228,22.189 5.349,21.067 6.728,21.067 C8.107,21.067 9.228,22.189 9.228,23.567 C9.228,24.945 8.107,26.067 6.728,26.067 M4,12.422 C4.001,12.285 4.069,9.075 7.921,9.075 C8.197,9.075 8.421,8.851 8.421,8.575 C8.421,3.077 13.595,3.001 13.815,3 C16.562,3 18.248,4.006 18.825,5.991 C18.899,6.244 19.155,6.399 19.416,6.339 C20.525,6.087 21.553,6.324 22.167,6.973 C22.674,7.508 22.826,8.245 22.597,9.047 C22.554,9.198 22.585,9.36 22.678,9.485 C22.773,9.61 22.921,9.684 23.078,9.684 C25.97,9.684 27,11.173 27,12.567 C27,14.693 25.709,16.067 23.71,16.067 L16.228,16.067 L15.228,16.067 L7.921,16.067 C5.832,16.067 4,14.363 4,12.422 M24.741,20.067 C23.914,20.067 23.162,20.368 22.562,20.85 L17.155,17.067 L23.71,17.067 C26.276,17.067 28,15.258 28,12.567 C28,10.753 26.658,8.922 23.68,8.706 C23.779,7.791 23.506,6.933 22.893,6.286 C22.122,5.471 20.929,5.108 19.641,5.283 C19.036,3.696 17.52,2 13.816,2 C13.718,2.025 11.03,2.011 9.151,3.886 C8.099,4.937 7.522,6.35 7.433,8.09 C3.053,8.367 3,12.378 3,12.42 C3,14.939 5.254,17.067 7.921,17.067 L14.313,17.067 L8.907,20.85 C8.307,20.368 7.555,20.067 6.728,20.067 C4.799,20.067 3.228,21.637 3.228,23.567 C3.228,25.497 4.799,27.067 6.728,27.067 C8.658,27.067 10.228,25.497 10.228,23.567 C10.228,22.83 9.997,22.147 9.605,21.582 L15.241,17.648 L15.241,23.119 C13.555,23.369 12.241,24.813 12.241,26.567 C12.241,28.497 13.811,30.067 15.741,30.067 C17.671,30.067 19.241,28.497 19.241,26.567 C19.241,24.804 17.927,23.356 16.228,23.116 L16.228,17.639 L21.864,21.582 C21.472,22.147 21.241,22.83 21.241,23.567 C21.241,25.497 22.811,27.067 24.741,27.067 C26.671,27.067 28.241,25.497 28.241,23.567 C28.241,21.637 26.671,20.067 24.741,20.067",
    id: "Networking-Content-Delivery_Category-Icon_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryNetworkingContentDelivery32);
export default __webpack_public_path__ + "static/media/Arch-Category_Networking-Content-Delivery_32.32faf1cbec9ecbf9c0aa65f6a5686dd4.svg";
export { ForwardRef as ReactComponent };